/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, action: NonNullable<unknown>, count: NonNullable<unknown> }} Endpoint_Network_HeadingInputs */

const en_endpoint_network_heading = /** @type {(inputs: Endpoint_Network_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.action} API pricing: one API, ${i?.count} interchangeable providers`)
};

const zh_hans1_endpoint_network_heading = /** @type {(inputs: Endpoint_Network_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.action} API 价格：一个 API，${i?.count} 个可互换的服务商`)
};

const pt_br2_endpoint_network_heading = /** @type {(inputs: Endpoint_Network_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preços do endpoint ${i?.action} da API para ${i?.name}: uma API, ${i?.count} provedores intercambiáveis`)
};

const es_endpoint_network_heading = /** @type {(inputs: Endpoint_Network_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Precios del endpoint ${i?.action} de la API de ${i?.name}: una API, ${i?.count} proveedores intercambiables`)
};

const fr_endpoint_network_heading = /** @type {(inputs: Endpoint_Network_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tarifs de l’API ${i?.name} ${i?.action} : une API, ${i?.count} fournisseurs interchangeables`)
};

const de_endpoint_network_heading = /** @type {(inputs: Endpoint_Network_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preise der ${i?.name}-${i?.action}-API: eine API, ${i?.count} austauschbare Anbieter`)
};

const ru_endpoint_network_heading = /** @type {(inputs: Endpoint_Network_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Цена API ${i?.name} ${i?.action}: один API, поставщиков ${i?.count}, и любой может заменить другого`)
};

const it_endpoint_network_heading = /** @type {(inputs: Endpoint_Network_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prezzi dell'API ${i?.name} ${i?.action}: una sola API, ${i?.count} provider intercambiabili`)
};

/**
* | output |
* | --- |
* | "{name} {action} API pricing: one API, {count} interchangeable providers" |
*
* @param {Endpoint_Network_HeadingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_network_heading = /** @type {((inputs: Endpoint_Network_HeadingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Network_HeadingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_network_heading(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_network_heading(inputs)
	if (locale === "es") return es_endpoint_network_heading(inputs)
	if (locale === "fr") return fr_endpoint_network_heading(inputs)
	if (locale === "de") return de_endpoint_network_heading(inputs)
	if (locale === "ru") return ru_endpoint_network_heading(inputs)
	if (locale === "it") return it_endpoint_network_heading(inputs)
	return en_endpoint_network_heading(inputs)
});